import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from 'modules/mac/messages';

import {
  StyledFlex,
  ContactWrapper,
  StyledLabel,
  StyledActionsButtonLink,
} from './StyledComponents';
import { MakePrimaryTooltip } from './Tooltips/MakePrimaryTooltip';
import { ContactTypeNames } from './DetailsRowContentElements/licensesRowContacts';
import { StyledPipe } from './ActionsSectionElements/StyledPipe';

type PropTypes = {
  name: string;
  contactId: string;
  email: string;
  main: boolean;
  noMakePrimary: boolean;
  canBePromoted: boolean;
  inactiveMakePrimary: boolean;
  canBeDeleted: boolean;
  deleteContact: (id: string, canBeDeleted: boolean) => () => void;
  openPromotionModal: (kind: ContactTypeNames) => void;
  setCurrentContactEmail: () => void;
  setCurrentContactId: (id: string) => void;
  setCurrentContactSmartDomain: (smartDomain: string) => void;
  smartDomain: string;
  id: string;
  isCloudAndNotBB: boolean;
  kind: ContactTypeNames;
};

export const ContactsActions: React.FC<PropTypes> = ({
  name,
  email,
  main,
  noMakePrimary,
  canBePromoted,
  inactiveMakePrimary,
  canBeDeleted,
  deleteContact,
  openPromotionModal,
  setCurrentContactEmail,
  setCurrentContactId,
  setCurrentContactSmartDomain,
  smartDomain,
  contactId,
  id,
  isCloudAndNotBB,
  kind,
}) => (
  <StyledFlex width="100%">
    <ContactWrapper width="25%" $textAlign="start">
      <p>{name}</p>
    </ContactWrapper>
    <ContactWrapper width="40%">
      <span>{email}</span>
    </ContactWrapper>
    <ContactWrapper $textAlign="end" width="35%">
      <span data-cy={`test-${email}${main ? '-main' : ''}`} key={`${kind}-${email}`}>
        {main ? (
          <StyledLabel>
            <FormattedMessage {...messages.primaryContact} />
          </StyledLabel>
        ) : (
          !isCloudAndNotBB && (
            <>
              {!noMakePrimary && (
                <>
                  {canBePromoted && (
                    <StyledActionsButtonLink
                      onClick={() => {
                        openPromotionModal(kind);
                        setCurrentContactEmail();
                        setCurrentContactId(contactId);
                        setCurrentContactSmartDomain(smartDomain);
                      }}
                    >
                      <FormattedMessage {...messages.makePrimary} />
                    </StyledActionsButtonLink>
                  )}
                  {inactiveMakePrimary && <MakePrimaryTooltip />}
                  {(canBePromoted || inactiveMakePrimary) && (
                    <>
                      {' '}
                      <StyledPipe />
                    </>
                  )}
                </>
              )}
              <StyledActionsButtonLink onClick={deleteContact(id, canBeDeleted)}>
                <FormattedMessage {...messages.delete} />
              </StyledActionsButtonLink>
            </>
          )
        )}
      </span>
    </ContactWrapper>
  </StyledFlex>
);
